import React from 'react';
import './philosophy.css';

const mentors = [
  {
    name: 'Subir Mandal Sir',
    role: 'Director and Physics Faculty',
    image: '/mode/subir_sir.jpeg',
    quote:
      'Dedicated teachers create disciplined learners, and disciplined learners makes dream come true.',
    details:
      'Subir Sir’s methods have guided students to IIT Delhi, Roorkee, Madras, and Guwahati while building multiple generations of medical professionals in MAMC,VMMC etc. from the same household.',
  },
  {
    name: "Sarika Meelu Ma'am",
    role: 'Director and Zoology Faculty',
    image: 'mode/Sarika_maam.jpg',
    quote:
      'When comfort tempts, I choose discipline.\nWhen silence is safer, I choose courage.\nWhen excuses exist, I choose results—For my students, always.',
    details:
      "Sarika Ma'am leads the personalized mentorship programmes that have produced national-level scholars across AIIMS, MAMC, VMMC, LHMC, AFMC, ACMS, KGMC, AIMS etc.  Olympiads, and JSTSE/NTSE stages.",
  },
];

const Philosophy: React.FC = () => (
  <main className="philosophy-page">
    <section className="philosophy-hero">
      <div className="hero-badge">Our Legacy</div>
      <h1>
        Subir Sir &amp; Sarika Ma'am <span>— the trusted duo of Dwarka</span>
      </h1>
      <p>
        With over 15 years of exclusive teaching mastery, they form Dwarka’s most trusted and result-oriented
        coaching pair. Their guidance has molded hundreds of success stories, including multiple generations of
        doctors within the same family—a rare testament to enduring trust and academic excellence.
      </p>
    </section>

    <section className="founder-section">
      {mentors.map((mentor) => {
        const quoteLines = mentor.quote.split('\n');

        return (
          <article key={mentor.name} className="founder-card">
            <div className="founder-image">
              <img src={mentor.image} alt={mentor.name} />
            </div>
            <div className="founder-content">
              <p className="founder-role">{mentor.role}</p>
              <h2>{mentor.name}</h2>
              <div className="quote-card">
                <span className="quote-icon">“</span>
                <p>
                  {quoteLines.map((line, index) => (
                    <React.Fragment key={`${mentor.name}-${index}`}>
                      {line}
                      {index < quoteLines.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
                <span className="quote-icon quote-icon--end">”</span>
              </div>
              <p className="founder-description">{mentor.details}</p>
            </div>
          </article>
        );
      })}
    </section>

    <section className="legacy-section">
      <h2>Our Legacy of Results</h2>
      <p>
        S Cubus founders have consistently delivered power-packed outcomes, ranging from foundation brilliance to
        engineering and medical milestones.
      </p>
      <ul>
        <li>Foundation excellence – NSEJS, JSTSE Rank 2, NTSE selections</li>
        <li>Medical triumphs – NEET Rank 126, numerous NEET qualifiers, NSEB and NSEP</li>
        <li>Engineering milestones – IIT Delhi, IIT Roorkee, IIT Madras, IIT Guwahati and more</li>
      </ul>
      <p className="legacy-note">
        These achievements reflect our commitment to concept clarity, exam temperament, and disciplined preparation.
      </p>
    </section>

    <section className="culture-section">
      <h2>Our Classroom Culture</h2>
      <p>At S Cubus, classrooms are built on:</p>
      <ul>
        <li>Strong academic values</li>
        <li>Relentless effort and consistency</li>
        <li>Personal mentorship and accountability</li>
      </ul>
      <p className="culture-affirmation">
        Here, success is not a distant goal—it is nurtured as a destiny. Dedicated, disciplined, and determined
        students always triumph.
      </p>
    </section>

    <section className="message-section">
      <h2>Message to Our Students</h2>
      <p className="message-hindi">
        जो छात्र समर्पित हैं,

        जो अनुशासित हैं,
        और जो दृढ़ संकल्पित हैं —
        सफलता उनके लिए विकल्प नहीं,
        निश्चित परिणाम होती है।
      </p>
    </section>
  </main>
);

export default Philosophy;
